import { createContext } from 'react';
export const NotificationSocketContext = createContext(null);
//# sourceMappingURL=notification-socket-context.js.map